export const Primitives = {
  green: {
    50: '#ECFDF5',
    100: '#D1FAE5',
    200: '#A7F3D0',
    300: '#6EE7B7',
    400: '#34D399',
    500: '#10B981',
    600: '#059669', //primary
    700: '#047857',
    800: '#065F46',
    900: '#064E3B',
  },
  cyan: {
    50: '#ECFEFF',
    100: '#CFFAFE',
    200: '#A5F3FC',
    300: '#67E8F9',
    400: '#22D3EE',
    500: '#06B6D4',
    600: '#0891B2',
    700: '#0E7490',
    800: '#155E75',
    900: '#164E63', //Secondary
  },
  gray: {
    50: '#F8FAFC', //Background
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569', //Text secondary
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A', //Text primary
  },
  orange: {
    50: '#FFF7ED',
    100: '#FFEDD5',
    200: '#FED7AA',
    300: '#FDBA74',
    400: '#FB923C',
    500: '#F97316', //Accent
    600: '#EA580C',
    700: '#C2410C',
    800: '#9A3412',
    900: '#7C2D12',
  },
  red: {
    50: '#FFF0F1',
    100: '#FFE0E2',
    200: '#FFC2C6',
    300: '#FF9198',
    400: '#F96370',
    500: '#E63946',
    600: '#C8202D',
    700: '#A31B26',
    800: '#821920',
    900: '#6A1920',
  }
};
